module.exports = __webpack_public_path__ + "281212429e2ca159d5848766e3476f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docs/zip-upload/zip-upload-3.png
// module id = 2481
// module chunks = 0